import React from "react";
import { Box, Button, Modal, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import CancelIcon from "@mui/icons-material/Cancel";
import IconButton from "@mui/material/IconButton";
import ExportBg from "../icons/export-bg.png";

export enum fileExportFormat {
  PDF = "PDF",
  CSV = "CSV",
}

export interface IFileExportDetails {
  exportAs: fileExportFormat;
  fileName: string;
}

interface IExportData {
  name: string;
  onExport: (fileType: fileExportFormat, fileName: string) => any;
  visible: boolean;
  toggleShowExportModal: () => void;
}

const useStyles = makeStyles(() => ({
  modalStyle: {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 320,
    height: 320,
    background: "#FFFFFF",
    boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.1)",
    borderRadius: "24px",
    backgroundImage: `url(${ExportBg})`,
    backgroundPosition: "50% 25%",
    backgroundSize: "175px auto",
    backgroundRepeat: "no-repeat",
    padding: "15px",
  },
  modalBottom: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    left: 0,
    marginLeft: "auto",
    marginRight: "auto",
    paddingBottom: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
  },
  iconButton: {
    position: "absolute",
    top: 5,
    right: 15,
    color: "#39A2DB",
    cursor: "pointer",
    zIndex: 11,
  },
  iconButtonBtn: {
    color: "#226183",
  },
  btnContainer: {
    textAlign: "center",
    width: "100%",
  },
  inputContainer: {
    display: "inline-block",
    width: "100%",
  },
  modalPreBottom: {
    display: "flex",
    alignItems: "center",
    paddingTop: 10,
  },
  mainBottom: {},
}));

const ExportDataModal = ({ name, onExport, visible, toggleShowExportModal }: IExportData) => {
  const classes = useStyles();

  const [exportFileName, setExportFileName] = React.useState(name);

  const exportFile = (fileType: fileExportFormat) => {
    onExport(fileType, exportFileName);
    toggleShowExportModal();
  };

  return (
    <Modal open={visible} onClose={toggleShowExportModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box className={classes.modalStyle}>
        <div className={classes.iconButton}>
          <IconButton onClick={toggleShowExportModal}>
            <CancelIcon color={"inherit"} className={classes.iconButtonBtn} />
          </IconButton>
        </div>
        <div style={{ width: "100%", height: "100%", position: "relative" }}>
          <Typography component="h1" variant="h6" noWrap sx={{ fontWeight: 600, fontFamily: "Work Sans, sans-serif", color: "#14142B", p: 1, textAlign: "center" }}>
            Confirm Export
          </Typography>
          <div className={classes.modalBottom}>
            <div className={classes.modalPreBottom}>
              <div
                style={{
                  display: "inline-block",
                  fontWeight: 600,
                  color: "#14142B",
                  textAlign: "left",
                  whiteSpace: "nowrap",
                  marginRight: 10,
                }}
              >
                File Name:
              </div>
              <div className={classes.inputContainer}>
                <TextField
                  name={"Exported File Name"}
                  id="standard-basic"
                  label={""}
                  variant="standard"
                  value={exportFileName}
                  onChange={(e) => setExportFileName(e.target.value)}
                  onKeyPress={(event) => (event.key === "Enter" ? exportFile(fileExportFormat.CSV) : "")}
                />
              </div>
            </div>
            <div className={classes.mainBottom}>
              <div
                style={{
                  fontWeight: 600,
                  color: "#14142B",
                  textAlign: "left",
                  paddingBottom: "10px",
                }}
              >
                Export as
              </div>
              <div className={classes.btnContainer}>
                <Button variant={"accountManagement"} sx={{ height: 40, width: 125, fontSize: 14, borderRadius: 24 }} onClick={() => exportFile(fileExportFormat.CSV)}>
                  CSV
                </Button>

                <Button variant="accountManagement" sx={{ height: 40, width: 125, fontSize: 14, ml: 2, borderRadius: 24 }} onClick={() => exportFile(fileExportFormat.PDF)}>
                  PDF
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ExportDataModal;
